import { schema } from 'normalizr';
import { omit } from 'underscore';

export const podcastDetailEpisodesSchema = new schema.Entity(
  'podcastDetailEpisodes',
  {},
  {
    idAttribute: 'episodeId',
  },
);

export const podcastsSchema = new schema.Entity(
  'podcasts',
  {
    episodes: [podcastDetailEpisodesSchema],
  },
  {
    idAttribute: 'podcastId',
    processStrategy: entity => omit(entity, 'nextEpisodePubAtMillis'),
  },
);

export const favoritePodcastsSchema = new schema.Entity(
  'favoritePodcasts',
  {},
  {
    idAttribute: 'podcastId',
  },
);

export const podcastSubscriptionSchema = new schema.Entity(
  'podcastSubscriptions',
  {},
  {
    idAttribute: 'autoCreateSubscriptionId',
  },
);

export const podcastWorkflowTemplatesSchema = new schema.Entity(
  'podcastWorkflowTemplates',
  {},
  {
    idAttribute: 'templateId',
  },
);

export const episodeClipSuggestionSchema = new schema.Entity(
  'episodeClipSuggestion',
  {},
  {
    idAttribute: 'suggestionId',
  },
);

export const groupClipSuggestionSchema = new schema.Entity(
  'groupClipSuggestion',
  {},
  {
    idAttribute: 'autoCreateEpisodeId',
  },
);

export const groupClipSuggestionsSchema = new schema.Entity(
  'groupClipSuggestions',
  { clipSuggestions: [groupClipSuggestionSchema] },
  {
    idAttribute: () => 'clipGroup',
  },
);

export const podcastFeedSchema = new schema.Entity(
  'podcastFeeds',
  {},
  {
    idAttribute: 'podcastFeedId',
    processStrategy: entity => ({
      ...entity,
      podcastFeedId: `${entity.podcastFeedId}`,
    }),
  },
);

export const ownedPodcastsSchema = new schema.Entity(
  'ownedPodcasts',
  {},
  {
    idAttribute: 'podcastFeedId',
  },
);

export const audioVariationsSchema = new schema.Entity('audioVariations', {});

export const autoCreateEpisodesSchema = new schema.Entity(
  'autoCreateEpisodes',
  {
    audioVariation: audioVariationsSchema,
  },
);

export const autoCreateEpisodeVideosSchema = new schema.Entity(
  'autoCreateEpisodeVideos',
  {
    autoCreateEpisode: autoCreateEpisodesSchema,
  },
  {
    idAttribute: 'videoId',
  },
);

export const podcastFeedEpisodesSchema = new schema.Entity(
  'podcastFeedEpisodes',
  {},
);

export const podcastEpisodesSchema = new schema.Entity('podcastEpisodes', {});

export const podcastRemoteEpisodesSchema = new schema.Entity(
  'podcastRemoteEpisodes',
  {},
  {
    idAttribute: 'episodeId',
  },
);

export const youtubeLanguageSchema = new schema.Entity(
  'youtubeLanguages',
  {},
  { idAttribute: 'languageCode' },
);

export const subscriptionItemInformationSchema = new schema.Entity(
  'subscriptionItemInformation',
);
